import { noop } from 'lodash-es';

// firebase perf doesn't work in web but this wrapper keeps API compatibility the same for what we are using
const getPerformance = () => ({
  newTrace: () => new MockTrace(),
});
const getApp = () => null;
export { getPerformance, getApp };

class MockTrace {
  start = function () {
    return Promise.resolve();
  };
  stop = function () {
    return Promise.resolve();
  };
  putAttribute = noop;
}
